export const Config = {
	id: '',
	params: {},
	fingerprint: '',
	external: false,
	version: 1
}
